export const body = '"Inter", sans-serif'
export const header = '"Gilroy-Semibold", "Inter", sans-serif'
